import { ChevronLeft } from "@mui/icons-material";
import { Link } from "react-router-dom";
import { useState } from "react";
import UploadModal from "./uploadAdsModal";
import { useLazyExportAdsQuery } from "src/store/services/adsApi";
import { toast } from "react-toastify";
import { Loading } from "../ui";
import { adTypes } from "src/pages/ads/adsLanding";

const AdsHeaderComp = ({
	callback,
	type,
}: {
	callback: () => void;
	type: string;
}) => {
	const [isUploadModalOpen, setIsUploadModalOpen] = useState(false);
	const [exportAds, { isLoading: isExporting }] = useLazyExportAdsQuery();

	const handleOpenUploadModal = () => {
		setIsUploadModalOpen(true);
	};

	const handleCloseUploadModal = () => {
		setIsUploadModalOpen(false);
	};

	const handleExport = async () => {
		try {
			const result = await exportAds(type).unwrap();
			toast.success(result.message || "Success!");
			if (result.payload?.data?.fileUrl) {
				window.open(result.payload.data.fileUrl);
			}
		} catch (error: any) {
			const errorMessage =
				error?.data?.error?.message ||
				error?.message ||
				"An error occurred while exporting";
			toast.error(errorMessage);
		}
	};

	return (
		<div className='flex flex-col md:flex-row gap-4 md:items-center justify-between'>
			<div className='flex items-center gap-2'>
				<Link to='/ads-management'>
					<ChevronLeft className='text-gray-700' />
				</Link>
				<h2 className='text-2xl font-semibold text-gray-700'>Ads Management</h2>
			</div>
			<div className='flex gap-4'>
				<button
					onClick={handleExport}
					disabled={isExporting}
					className='p-2 px-10 text-white bg-primary rounded-lg hover:bg-opacity-90 transition-colors flex items-center justify-center'
				>
					{isExporting ? <Loading color='white' /> : "Export"}
				</button>
				<button
					onClick={handleOpenUploadModal}
					className='p-2 px-10 text-white bg-[#55C4F1] rounded-lg hover:bg-[#44a3d1] transition-colors'
				>
					Upload
				</button>
			</div>
			<UploadModal
				isOpen={isUploadModalOpen}
				onClose={handleCloseUploadModal}
				callback={callback}
			/>
		</div>
	);
};

export default AdsHeaderComp;
